import {
  Component,
  Input,
  Output,
  QueryList,
  ContentChildren,
  ViewChild,
  AfterContentInit,
  EventEmitter,
} from "@angular/core";
import { WizardStepComponent } from "./wizard-step.component";
import { WizardSummaryComponent } from "./wizard-summary.component";
import { BeforeNextStepEventHandler } from "./before-next-step.event";
import { ApplyState } from "./wizard-nav.component";
@Component({
  selector: "icn-wizard",
  templateUrl: "./wizard.component.html",
  styleUrls: ["./wizard.component.scss"],
})
export class WizardComponent implements AfterContentInit {
  @Input()
  header: string;

  @Input()
  stepTitle: string;

  @Input()
  doneTitle: string;

  @Input()
  themeColor: "cyan" | "purple" = "purple";

  @Input() editMode = false;

  @Output() apply = new EventEmitter();

  @Input()
  applyState: ApplyState = ApplyState.Unknown;

  @Output() onNextEvent = new EventEmitter();

  @Output() onBackEvent = new EventEmitter();

  currentStep: WizardStepComponent;

  wizardHeaders: Array<string> = [];

  @ContentChildren(WizardStepComponent) steps: QueryList<WizardStepComponent>;
  @ViewChild(WizardSummaryComponent, { static: true })
  summary: WizardSummaryComponent;

  ngAfterContentInit() {
    this.summary.steps = this.steps.toArray();

    this.currentStep = this.steps.first;
    this.currentStep.isCurrent = true;

    this.steps.forEach((step: WizardStepComponent, index: number) => {
      step.stepIndex = index;
      if (!step.isDoneStep) {
        this.wizardHeaders.push(step.name);
      }
    });
  }

  isBackHidden() {
    return this.currentStep.isBackHidden();
  }

  isNextDisabled() {
    return this.currentStep.isNextDisabled();
  }

  isNextHidden() {
    if (this.editMode && this.steps.length - 2 === this.currentStep.stepIndex) {
      return true;
    }
    return this.currentStep.isNextHidden();
  }

  isApplyHidden() {
    if (!this.editMode) {
      return true;
    }
    return this.currentStep.isNextHidden();
  }

  isApplyDisabled() {
    return this.currentStep.isNextDisabled();
  }

  /**
   *
   */
  onApply() {
    this.apply.next(true);
  }

  /**
   * Next dispacher - navigate the wizard's steps forward
   * @return void
   */
  onNext() {
    let subStep = false;

    /* Nexting SUB-STEP */
    if (this.currentStep.hasNext) {
      this.currentStep.next();
      subStep = true;
    } else {
      const canContinue = new EventEmitter<boolean>();
      const self = this;
      canContinue.subscribe((cont) => {
        canContinue.complete();
        if (cont) {
          self.currentStep.isCurrent = false;
          self.currentStep =
            self.steps.toArray()[self.currentStep.stepIndex + 1];
          self.currentStep.isCurrent = true;
        }
      });

      const beforeNextStepEvent = new BeforeNextStepEventHandler(canContinue);

      if (!!this.currentStep.beforeNextStep) {
        this.currentStep.beforeNextStep(beforeNextStepEvent);
      } else {
        beforeNextStepEvent.next();
      }
    }

    /* Dispatch next event */
    this.onNextEvent.emit({
      previousStep: this.currentStep,
      subStep: subStep,
    });
  }

  onBack() {
    let subStep = false;

    if (this.currentStep.hasBack) {
      this.currentStep.back();
      subStep = true;
    } else {
      this.currentStep.isCurrent = false;
      this.currentStep = this.steps.toArray()[this.currentStep.stepIndex - 1];
      this.currentStep.last();
      this.currentStep.isCurrent = true;
    }

    /* Dispatch next event */
    this.onBackEvent.emit({
      previousStep: this.currentStep,
      subStep: subStep,
    });
  }

  jumpIfCan(index) {
    if (index === this.currentStep.stepIndex) {
      return;
    } else {
      if (this.isNextDisabled()) {
        return;
      } else {
        this.currentStep.isCurrent = false;
        this.currentStep = this.steps.toArray()[index];
        this.currentStep.first();
        this.currentStep.isCurrent = true;
      }
    }
  }
}
